export const mainColor = state => {
    // return 'rgb(26, 188, 156)'
    return '#323746'
}


// WEBPACK FOOTER //
// ./src/store/getters.js